package com.example.monetix.ui.theme

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.darkColorScheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.lerp

private val MonetixLightColorScheme = lightColorScheme(
    background = LightBackground,
    surface = LightSurface,
    primary = LightPrimary,
    onPrimary = LightOnPrimary,
    onBackground = LightText,
    onSurface = LightText,
    onSurfaceVariant = LightTextMuted,
    error = ColorExpense,
    primaryContainer = LightSurface,
    secondary = ColorIncome,
    tertiary = ColorTransfer
)

private val MonetixDarkColorScheme = darkColorScheme(
    background = DarkBackground,
    surface = DarkSurface,
    primary = DarkPrimary,
    onPrimary = DarkOnPrimary,
    onBackground = DarkText,
    onSurface = DarkText,
    onSurfaceVariant = DarkTextMuted,
    error = ColorExpense,
    primaryContainer = DarkSurface,
    secondary = ColorIncome,
    tertiary = ColorTransfer
)

@Composable
fun MonetixTheme(
    darkTheme: Boolean = isSystemInDarkTheme(), // Legge in automatico il sistema!
    content: @Composable () -> Unit
) {
    val colorScheme = if (darkTheme) MonetixDarkColorScheme else MonetixLightColorScheme

    MaterialTheme(
        colorScheme = colorScheme,
        // Qui potresti aggiungere anche una typography personalizzata
        content = content
    )
}
@Composable
fun getDynamicBalanceColor(currentBalanceCents: Long, safetyBufferCents: Long): Color {
    return when {
        // 🟢 Sopra la soglia: Verde
        currentBalanceCents >= safetyBufferCents -> Color(0xFF10B981)

        // 🔴 A zero (o sotto): Rosso del tema
        currentBalanceCents <= 0L -> MaterialTheme.colorScheme.error

        // 🟠🟡 Sfumatura Arancione -> Rosso
        else -> {
            val fraction = currentBalanceCents.toFloat() / safetyBufferCents.toFloat()
            val dangerColor = MaterialTheme.colorScheme.error
            val warningColor = Color(0xFFF59E0B) // Arancione

            lerp(start = dangerColor, stop = warningColor, fraction = fraction)
        }
    }
}